import { BillingStageScheduleType } from '~/models';
export const defaultScheduleForType = (type)=>{
    switch(type){
        case BillingStageScheduleType.Manual:
            return {
                type
            };
        case BillingStageScheduleType.OnEffectiveDate:
            return {
                type
            };
        case BillingStageScheduleType.RequiresDateSelection:
            return {
                type
            };
        case BillingStageScheduleType.RelativeToEffectiveDate:
            return {
                type,
                relativeToEffectiveDate: {
                    days: 30
                }
            };
        case BillingStageScheduleType.OnDate:
            return {
                type,
                onDate: {
                    date: ''
                }
            };
    }
};
